import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { URL_MAP } from '../../shared/urlMap';
import { environment as ENV } from '../../../environments/environment';
import { ContratoAfilmedDTO } from '../../models/contrato-afilmed/contrato-afilmed.model';

export interface ContratosUsersRequest {
  prm_docu_tipo?: string;
  prm_docu_nro?: string;
  prm_contra?: string;
  prm_linea_negocio?: string;
  prm_estado_contrato?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ContratosUsersService {
  private apiUrl = `${ENV.HOST}${URL_MAP.API.CONTRATOS_USER}`;

  constructor(private http: HttpClient) {}

  getContratosUsers(
    params: ContratosUsersRequest,
  ): Observable<ContratoAfilmedDTO[]> {
    const body = {
      jsonParametros: JSON.stringify(params),
    };

    return this.http.post<unknown>(this.apiUrl, body).pipe(
      map((response) =>
        ContratosUsersService.extractItemsArray(response).map((item) =>
          ContratosUsersService.mapContrato(item),
        ),
      ),
    );
  }

  private static extractItemsArray(raw: unknown): any[] {
    const visitados = new WeakSet<object>();

    const extraer = (r: unknown, depth: number): any[] => {
      if (r == null || depth > 10) {
        return [];
      }
      if (Array.isArray(r)) {
        return r;
      }
      if (typeof r === 'string') {
        const t = r.trim();
        if (t.startsWith('[') || t.startsWith('{')) {
          try {
            return extraer(JSON.parse(t), depth + 1);
          } catch {
            return [];
          }
        }
        return [];
      }
      if (typeof r !== 'object') {
        return [];
      }
      const o = r as Record<string, unknown>;
      if (visitados.has(o)) {
        return [];
      }
      visitados.add(o);

      for (const key of [
        'data',
        'Data',
        'result',
        'content',
        'jsonRespuesta',
        'JsonRespuesta',
        'resultado',
        'Resultado',
      ]) {
        const inner = o[key];
        if (inner != null) {
          const got = extraer(inner, depth + 1);
          if (got.length > 0) {
            return got;
          }
        }
      }
      return [];
    };

    return extraer(raw, 0);
  }

  private static mapContrato(item: any): ContratoAfilmedDTO {
    const nitRaw = String(
      item?.Nit ?? item?.nit ?? item?.NIT ?? item?.nitEmpresa ?? '',
    ).trim();

    return {
      ...item,
      contrato: String(item?.contrato ?? item?.Contrato ?? '').trim(),
      ...(nitRaw ? { Nit: nitRaw } : {}),
      ColectivoEspecial:
        item?.ColectivoEspecial ?? item?.colectivoEspecial ?? null,
      TipoPrima: item?.TipoPrima ?? item?.tipoPrima ?? null,
    } as ContratoAfilmedDTO;
  }
}
